import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import classnames from 'classnames'
import ShareIcon from 'transfix-icons/build/ShareIcon'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useFeatureFlagContext } from 'utils/context/FeatureFlagsContext'
import { ILoad, ILoadDetailsState } from 'apps/fleet-planner/types'
import { loadDetailsSelector } from 'apps/fleet-planner/utils/selectors/load'
import { IStore } from 'apps/fleet-planner/utils/types/store'
import { Fab } from 'transfix-ui'
import { LoadDetailsActions } from './LoadDetailsActions'

interface ILoadHeaderProps {
  load: ILoad
  isExternal?: boolean
}
export const LoadDetailsHeader = memo<ILoadHeaderProps>(({ isExternal = false, load }) => {
  const { getFlag } = useFeatureFlagContext()
  const { enabled: isFmsOneTimeSmsLoadShareEnabled } = getFlag('fmsOneTimeSmsLoadShare')
  const { isMobile } = useBreakpointContext()
  const { pathname = '' } = useLocation()
  const { load: shipment } = useSelector<IStore, ILoadDetailsState>(loadDetailsSelector)
  const { drivers } = shipment || {}
  const [driverOne] = drivers || []
  const isAssigned = driverOne?.id
  const shareRoute =
    isFmsOneTimeSmsLoadShareEnabled && !isExternal && isAssigned ? 'share-load-via-sms' : 'share'

  const classes = classnames('dib', {
    pr2: isExternal,
    pl2: isMobile,
  })

  return (
    <div className='flex items-center pr2'>
      {isMobile ? (
        <Link to={`${pathname}/${shareRoute}`}>
          <Fab aria-label='More...' color='primary'>
            <ShareIcon />
          </Fab>
        </Link>
      ) : (
        <div className={classes} data-test='load-details-share-button'>
          <Link to={`${pathname}/${shareRoute}`} className='btn btn-primary btn-large'>
            Share
          </Link>
        </div>
      )}
      {!isExternal && (
        <div className='dib' data-test='load-details-overflow-button'>
          <LoadDetailsActions load={load} isExternal={isExternal} />
        </div>
      )}
    </div>
  )
})
